import { types } from 'mobx-state-tree';

const RelatedProduct = types.model('RelatedProduct', {
  recommended_ids: types.array(types.string),
  alternative_ids: types.array(types.string)
});

export default RelatedProduct;
